import { handleActions } from 'redux-actions';

import { ADD_NOTIFICATION, REMOVE_NOTIFICATION } from './consts';

const initialState = {
	notifications: [],
};

export const notificationsReducer = handleActions(
	{
		[ADD_NOTIFICATION]: (state, { payload: notification }) => ({
			...state,
			notifications: [{ ...notification }, ...state.notifications],
		}),
		[REMOVE_NOTIFICATION]: (state, { payload: id }) => ({
			...state,
			notifications: state.notifications.filter((x) => x.id !== id),
		}),
	},
	initialState,
);
